import { render, staticRenderFns } from "./DetectionDetailPanel.vue?vue&type=template&id=794f1b23"
import script from "./DetectionDetailPanel.vue?vue&type=script&lang=js"
export * from "./DetectionDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./DetectionDetailPanel.vue?vue&type=style&index=0&id=794f1b23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports